import React from "react";
import ReactDOM from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import reducer from "./store/reducer";
import config from "./config";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import {
  MAESTROAPPS_RESOURCE_GUID,
  CONTAINER_CLOUD_RESOURCE_GUID,
  GEO_FENCING_RESOURCE_GUID,
} from "./App/serverConfig";
import {
  raToolAuthGetTokenForResource,
  geoFancingAuthGetTokenForResource,
  maestroAppsAuthGetTokenForResource,
  containerCloudAuthGetTokenForResource,
} from "./tokenConfig";

import RaToolAADService from "./RaToolAADService";
import GeoFancingAADService from "./GeoFancingAADService";
import ContainerCloudAADService from "./ContainerCloudAADService";
import MaestroAppsAADService from "./MaestroAppsAADService";
import pennyReducer from "./store/pennyReducer";
import boxViewReducer from "./store/boxViewReducer";

const store = configureStore({
  reducer: {
    appLayout: reducer,
    pennyPressure: pennyReducer,
    boxView: boxViewReducer,
  },
});

const raToolAADService = new RaToolAADService();
raToolAuthGetTokenForResource(MAESTROAPPS_RESOURCE_GUID)
  .then((token) => {
    raToolAADService.setRaToolToken(token);
  })
  .catch((error) => console.log(error));

// Need to remove this changes once dev environment is ready for RA tool or geo fancing.
/**      ################# Start ################## **/
const geoFancingAADService = new GeoFancingAADService();
geoFancingAuthGetTokenForResource(GEO_FENCING_RESOURCE_GUID)
  .then((token) => {
    geoFancingAADService.setGeoFancingToken(token);
  })
  .catch((error) => console.log(error));

/**      ################# End ################## **/

/** ContainerCloudAADService config */
/**      ################# Start ################## **/
const containerCloudAADService = new ContainerCloudAADService();
containerCloudAuthGetTokenForResource(CONTAINER_CLOUD_RESOURCE_GUID)
  .then((token) => {
    containerCloudAADService.setContainerCloudToken(token);
  })
  .catch((error) => console.log(error));

/**      ################# End ################## **/

// Need to remove this changes once dev environment is ready for penny pressure.
/**      ################# Start ################## **/
const pennyAADService = new MaestroAppsAADService();
maestroAppsAuthGetTokenForResource(MAESTROAPPS_RESOURCE_GUID)
  .then((token) => {
    pennyAADService.setPennyToken(token);
  })
  .catch((error) => console.log(error));

/**      ################# End ################## **/
const app = (
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
